import React from "react";
import PropTypes from "prop-types";
import {
  SFTrendUpIcon,
  SFTrendDownIcon,
  SFTrendingFlat,
  SFTimelapseIcon,
} from "../icons";
import SFHaloIconWrapper from "../icons/halo";
import { TRENDS } from "../../constants/trends";

export const getTrendColor = (trend, variant) => {
  if (variant === "secondary") {
    return "grey";
  }
  switch (trend) {
  case TRENDS.increasing:
    return "green";
  case TRENDS.decreasing:
    return "red";
  case TRENDS.maintaining:
  default:
    return "maroon";
  }
};

export const SFTrendIcon = ({ trend, variant = "primary", size = "small" }) => {
  switch (trend) {
  case TRENDS.increasing:
    return (
      <SFTrendUpIcon
        size={size}
        color={variant === "primary" ? "green600" : "green400"}
      />
    );
  case TRENDS.decreasing:
    return (
      <SFTrendDownIcon
        size={size}
        color={variant === "primary" ? "red600" : "red400"}
      />
    );
  case TRENDS.maintaining:
    return (
      <SFTrendingFlat
        size={size}
        color={variant === "primary" ? "maroon200" : "blue400"}
      />
    );
  case TRENDS.pending:
  default:
    return (
      <SFTimelapseIcon
        size={size}
        color="orange300"
      />
    );
  }
};

SFTrendIcon.propTypes = {
  trend: PropTypes.oneOf(Object.values(TRENDS)),
  variant: PropTypes.oneOf(["primary", "secondary"]),
};

export const SFTrendHaloIcon = ({
  trend,
  size = "small",
  variant = "primary",
}) => {
  return (
    <SFHaloIconWrapper
      size={size}
      variant={getTrendColor(trend, variant)}
      ignoreIcon
    >
      <SFTrendIcon trend={trend} variant={variant} />
    </SFHaloIconWrapper>
  );
};

SFTrendHaloIcon.propTypes = {
  trend: PropTypes.oneOf(Object.values(TRENDS)),
  size: SFHaloIconWrapper.propTypes.size,
  variant: PropTypes.oneOf(["primary", "secondary"]),
};
